<form [formGroup]="addressForm" class="max-w-5xl space-y-6" (ngSubmit)="saveAddress()">
  <details [open]="openSection === 'current'" class="group">
    <summary class="cursor-pointer list-none flex items-center gap-2 text-sm font-semibold text-slate-700" (click)="toggleSection('current', $event)">
      <span class="inline-block w-4 text-center group-open:rotate-90 transition-transform">&#9656;</span>
      Current Address
    </summary>
    <div class="mt-3 bg-zinc-100 border rounded-md p-6 space-y-4" [formGroup]="currentAddress">
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Address</label>
        <div>
          <input type="text" max="500" class="input input-bordered w-full" formControlName="address" placeholder="Enter current address">
          @if (currentAddress.get('address')?.errors && currentAddress.get('address')?.touched) {
            <div class="text-error text-xs mt-1">
              {{ getFieldError(currentAddress.get('address'), 'current.address') }}
            </div>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">City</label>
        <div>
          <input type="text" max="100" class="input input-bordered w-full" formControlName="city" placeholder="Enter city">
          @if (currentAddress.get('city')?.errors && currentAddress.get('city')?.touched) {
            <div class="text-error text-xs mt-1">
              {{ getFieldError(currentAddress.get('city'), 'current.city') }}
            </div>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">District</label>
        <div>
          <input type="text" max="100" class="input input-bordered w-full" formControlName="district" placeholder="Enter district">
          @if (currentAddress.get('district')?.errors && currentAddress.get('district')?.touched) {
            <div class="text-error text-xs mt-1">
              {{ getFieldError(currentAddress.get('district'), 'current.district') }}
            </div>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">State</label>
        <div>
          <input type="text"  max="100" class="input input-bordered w-full" formControlName="state" placeholder="Enter state">
          @if (currentAddress.get('state')?.errors && currentAddress.get('state')?.touched) {
            <div class="text-error text-xs mt-1">
              {{ getFieldError(currentAddress.get('state'), 'current.state') }}
            </div>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Pincode</label>
        <div>
          <input type="number" class="input input-bordered w-full" formControlName="pincode" placeholder="Enter pincode">
          @if (currentAddress.get('pincode')?.errors && currentAddress.get('pincode')?.touched) {
            <div class="text-error text-xs mt-1">
              {{ getFieldError(currentAddress.get('pincode'), 'current.pincode') }}
            </div>
          }
        </div>
      </div>
      <!-- <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Country</label>
        <input type="text" max="100" class="input input-bordered w-full" formControlName="country" placeholder="Enter country">
      </div> -->
    </div>
  </details>

  <details [open]="openSection === 'permanent'" class="group">
    <summary class="cursor-pointer list-none flex items-center justify-between gap-2 text-sm font-semibold text-slate-700" (click)="toggleSection('permanent', $event)">
      <span class="flex items-center gap-2">
        <span class="inline-block w-4 text-center group-open:rotate-90 transition-transform">&#9656;</span>
        Permanent Address
      </span>
      <button type="button" class="text-xs text-primary underline hover:text-primary-focus" (click)="copyCurrentToPermanent($event)">
        Use same as current address
      </button>
    </summary>
    <div class="mt-3 bg-zinc-100 border rounded-md p-6 space-y-4" [formGroup]="permanentAddress">
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Address</label>
        <div>
          <input type="text" max="500" class="input input-bordered w-full" formControlName="address" placeholder="Enter permanent address">
          @if (permanentAddress.get('address')?.errors && permanentAddress.get('address')?.touched) {
            <div class="text-error text-xs mt-1">
              {{ getFieldError(permanentAddress.get('address'), 'permanent.address') }}
            </div>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">City</label>
        <div>
          <input type="text" max="100" class="input input-bordered w-full" formControlName="city" placeholder="Enter city">
          @if (permanentAddress.get('city')?.errors && permanentAddress.get('city')?.touched) {
            <div class="text-error text-xs mt-1">
              {{ getFieldError(permanentAddress.get('city'), 'permanent.city') }}
            </div>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">District</label>
        <div>
          <input type="text" max="100" class="input input-bordered w-full" formControlName="district" placeholder="Enter district">
          @if (permanentAddress.get('district')?.errors && permanentAddress.get('district')?.touched) {
            <div class="text-error text-xs mt-1">
              {{ getFieldError(permanentAddress.get('district'), 'permanent.district') }}
            </div>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">State</label>
        <div>
          <input type="text" max="100" class="input input-bordered w-full" formControlName="state" placeholder="Enter state">
          @if (permanentAddress.get('state')?.errors && permanentAddress.get('state')?.touched) {
            <div class="text-error text-xs mt-1">
              {{ getFieldError(permanentAddress.get('state'), 'permanent.state') }}
            </div>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Pincode</label>
        <div>
          <input type="text" max="6" class="input input-bordered w-full" formControlName="pincode" placeholder="Enter pincode">
          @if (permanentAddress.get('pincode')?.errors && permanentAddress.get('pincode')?.touched) {
            <div class="text-error text-xs mt-1">
              {{ getFieldError(permanentAddress.get('pincode'), 'permanent.pincode') }}
            </div>
          }
        </div>
      </div>
      <!-- <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Country</label>
        <input type="text" max="100" class="input input-bordered w-full" formControlName="country" placeholder="Enter country">
      </div> -->
    </div>
  </details>

  <div class="flex justify-end">
    <button type="submit" class="btn btn-primary" [disabled]="isSaving">
      {{ isSaving ? 'Saving...' : 'Save Address' }}
    </button>
  </div>
</form>
